module.exports = __webpack_public_path__ + "img/btn-google@2x.311f9c52.png";